(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name rutaService
     *@description
     *Servicio de Rutas
     */

    angular
        .module('app')
        .factory('rutaService', rutaService);

    rutaService.$inject = ["$http","$filter","$location","espaiService","$q","$timeout","autorService"];

    function rutaService($http,$filter,$location,espaiService,$q,$timeout,autorService) {    
        

    	var rutas = {};

        rutas.search = false;
        rutas.lastLang = 1;

    	rutas.getRutasByAutor= function(autor)
    	{
            
    		var data = [],b =false ;
            if(!rutas.data)
                return data;
            
    		for (var i = 0; i < rutas.data.length; i++) {
    			if(rutas.data[i].data.autor == autor)
    			{
                    b = false;
                    for (var j = 0; j < rutas.data[i].espais.length; j++) {

                        if (espaiService.getEspaiByID(rutas.data[i].espais[j].espai_id) )
                        {
                            b = true;
                        }
                    }
                    if(b)
    				    data.push(rutas.data[i]);
    			}
    		}
    		return data;
    	};


        rutas.getRutaData = function(espai)
        {
            //console.log(espai);
            if(!rutas.data)
               return false;
            var b = false ;
            for (var i = 0; i < rutas.data.length; i++) {
                for (var j = 0; j < rutas.data[i].espais.length; j++) {
                    if(rutas.data[i].espais[j].espai_id == espai){
                        
                        
                        return rutas.data[i];
                    }

                }
            }
            return b;
        };

        rutas.getRutaID = function(espai)
        {
            //console.log(espai);
            if(!rutas.data)
               return false;
            var b = false ;
            for (var i = 0; i < rutas.data.length; i++) {
                for (var j = 0; j < rutas.data[i].espais.length; j++) {
                    if(rutas.data[i].espais[j].espai_id == espai){
            
                        
                        return rutas.data[i].espais[j].ruta_id;
                    }

                }
            }
            return b;
        };

        rutas.getEspais = function(espai)
        {
            if(!rutas.data)
               return [];
            
            var b = [],i=0,j=0 ;
            var rutaId = 0 ;
            for ( i = 0; i < rutas.data.length; i++) {
                for ( j = 0; j < rutas.data[i].espais.length; j++) {
                    
                    if(rutas.data[i].espais[j].espai_id == espai){
                        //console.log(rutas.data[i].espais);
                        rutaId = rutas.data[i].id;
                        //return rutas.data[i].espais;
                    }

                }
            }
            
            for ( i = 0; i < rutas.data.length; i++) {
                for ( j = 0; j < rutas.data[i].espais.length; j++) {
                    if(espaiService.getEspaiByID(rutas.data[i].espais[j].espai_id) && rutaId == rutas.data[i].id )
                    {
                        b.push( rutas.data[i].espais[j] );
                    }    
                }
            }

            return b;
        };

        rutas.getExperienciesByEspai = function(espai)
        {
            
            if(!rutas.data)
               return [];
            var b = [] ;
            for (var i = 0; i < rutas.data.length; i++) {
                for (var j = 0; j < rutas.data[i].espais.length; j++) {
                    if(rutas.data[i].espais[j].espai_id == espai){
                        console.log(rutas.data[i]);

                        if(!rutas.data[i].experiencies)
                                return [];

                        return rutas.data[i].experiencies;
                    }

                }
            }
            return b;
        };

        rutas.next = function(id,ordre)
        {
            //console.log(id);
            rutas.number(id,ordre);
        };

        rutas.back = function(id,ordre)
        {
            rutas.number(id,ordre);
        };

        rutas.number = function(id , ordre)
        {
            if(!rutas.data)
                return false;
            var b = false ;
            for (var i = 0; i < rutas.data.length; i++) {

                for (var j = 0; j < rutas.data[i].espais.length; j++) {

                    if(rutas.data[i].espais[j].ordre == ordre && rutas.getRutaID(id) == rutas.data[i].espais[j].ruta_id){

                        var espai = espaiService.getEspaiByID(rutas.data[i].espais[j].espai_id);
                        if(espai){
                            var autor = autorService.getAutorByID(espai.data.autor);
                            $location.path( '/'+language+'/espai/'+$filter('slugify')(espai.data.nom_ca)+"/"+$filter('slugify')(autor.data.nom+' '+autor.data.cognoms) ) ;
                        }
                        
                    }

                }
            }
            return b;
        };



        rutas.position = function(espai,number){
            if(!rutas.data)
                return false;
            
            var b = false ;
            for (var i = 0; i < rutas.data.length; i++) {
                for (var j = 0; j < rutas.data[i].espais.length; j++) {
                    if(rutas.data[i].espais[j].espai_id == espai){
                        
                        return (number == rutas.data[i].espais[j].ordre);
                    }

                }
            }
            return b;
        };
         rutas.getPosition = function(espai){
            if(!rutas.data)
                return false;
            
            for (var i = 0; i < rutas.data.length; i++) {
                for (var j = 0; j < rutas.data[i].espais.length; j++) {
                    if(rutas.data[i].espais[j].espai_id == espai){
                        return rutas.data[i].espais[j].ordre;
                    }

                }
            }
            return 0;
        };

        rutas.EspaisIsRuta = function(espai)
        {

            if(!rutas.data)
                return false;
            var b = false ;
            for (var i = 0; i < rutas.data.length; i++) {
                for (var j = 0; j < rutas.data[i].espais.length; j++) {
                    if(rutas.data[i].espais[j].espai_id == espai){
                        b = true;
                        return b;
                    }

                }
                
            }
            return b;
        };
        /**
        * @ngdoc method
        * @name getRutas
        * @memberof ExperienceIsRuta
        * @desciption
        * Dice si una experiencia esta en una ruta
        */
        rutas.ExperienceIsRuta = function(espai)
        {

            if(!rutas.data)
                return false;
            var b = false ;
            for (var i = 0; i < rutas.data.length; i++) {
                for (var j = 0; j < rutas.data[i].espais.length; j++) {
                    if(rutas.data[i].espais[j].espai_id == espai){

                        if(!rutas.data[i].experiencies)
                                return false;
                        
                        return rutas.data[i].experiencies.length;
                    }

                }
                
            }
            return b;
        };
        /**
        * @ngdoc method
        * @name getRutas
        * @memberof setAutorName
        * @desciption
        * Setea un autorName
        */
        rutas.setAutorName = function()
        {
            for (var i = 0; i < rutas.data.length; i++) {
                           
                 rutas.data[i].autor_name = autorService.getAutorByID(rutas.data[i].data.autor)

                
            }

        };

        /**
        * @ngdoc method
        * @name getRuta
        * @memberof rutaService
        * @desciption
        * Obti
        */

        rutas.getRuta = function(ruta)
        {
            for (var i = 0; i < rutas.data.length; i++) {
                if(rutas.data[i].id == ruta)
                {
                    return rutas.data[i];
                }
            }
            return false;
        };

    	/**
        * @ngdoc method
        * @name getRutas
        * @memberof rutaService
        * @desciption
        * Obtienes las rutas.
        */
        rutas.load = false;
    	rutas.getRutas = function (){
            var deferred = $q.defer();


            if(rutas.data && espaiService.lang == rutas.lastLang ){
                $timeout(function(){
                    deferred.resolve(rutas.data);
                },20);
            }else{
            
                rutas.load = true;
                var url= '/api/v1/rutas';
                $http({
                    method  : 'GET',
                    url     : url,
                    params : {
                        lang: espaiService.lang
                    }
                
                })
                .then(Success)
                .catch(Failed);
            }
            
            function Success(data){  
                rutas.load = false;
            	rutas.data = data.data;
                rutas.setAutorName();
                rutas.lastLang = espaiService.lang;
                return rutas.getExperiencies().then(function()
                    {
                        
                        rutas.getExperienciesByRutas();     
                        rutas.getExperienciesByEspais();                   
                        //console.log(rutas.data);
                        deferred.resolve(data.data);
                    });
                //return data.data;
            }

            function Failed(data){
                //console.log(data);
                deferred.reject(false);
            }

            return deferred.promise;
        };

         /**
        * @ngdoc method
        * @name visibleAll
        * @memberof rutaService
        * @desciption
        * Cambia la propiedad visible a true de todos loas rutaes
        */
        rutas.visibleAll = function()
        {

            for (var i = 0; i < rutas.data.length; i++) {
                
                rutas.data[i].visible = true ;
            }

        };

        /**
        * @ngdoc method
        * @name invisibleAll
        * @memberof rutaService
        * @desciption
        * Cambia la propiedad visible a false de todos loas autores
        */
        rutas.invisibleAll = function()
        {

            for (var i = 0; i < rutas.data.length; i++) {
                rutas.data[i].visible = false ;
            }

        };

        rutas.getExperienciesByRutas = function()
        {
            for (var i = 0; i < rutas.data.length; i++) {
                rutas.data[i].visible = true;
                var idRuta = rutas.data[i].id;
                rutas.data[i].experiencies = [];
                for (var j = 0; j < rutas.experiencies.length; j++) {
                    if(idRuta == rutas.experiencies[j].data.ruta)
                    {
                        rutas.data[i].experiencies.push(rutas.experiencies[j].data); 
                    }
                }
                
            }
        };

        rutas.getExperienciesByEspais = function()
        {
            for (var i = 0; i < espaiService.data.length; i++) {
                espaiService.data[i].experiencies = [];
                for (var j = 0; j < rutas.experiencies.length; j++) {
                    if(espaiService.data[i].id == rutas.experiencies[j].data.espai)
                    {
                        espaiService.data[i].experiencies.push(rutas.experiencies[j].data); 
                    }
                }
                
            }
        };

        /**
        * @ngdoc method
        * @name getExperiencies
        * @memberof rutaService
        * @desciption
        * Obtienes las experiencias
        .
        */
        rutas.getExperiencies = function (){
            var url= '/api/v1/experiencies';
             return $http({
                method  : 'GET',
                url     : url,
                params    : {
                    "lang":language
                }
                
            })
                .then(Success)
                .catch(Failed);
            
            function Success(data){  
                rutas.experiencies = data.data;
                return data.data;
            }

            function Failed(data){
                //console.log(data);
                return false;
            }
        };


    	return rutas;
    }



})();
